import React from 'react';

function Sobre() {
  return (
    <section id="sobre" className="sobre">
      <div className="sobre-content">
        <div className="sobre-text">
          <h3>Quem está por trás da OnlinUp</h3>
          <p>
            Olá! Sou a Patrícia, criadora da OnlinUp. Sou desenvolvedora, marketeira e testadora com paixão por criar soluções digitais que realmente funcionam. Combinando código e testes rigorosos, entrego produtos de alta qualidade.
          </p>
  <p>
            Na OnlinUp, acreditamos que tecnologia de qualidade não deve ser 
            complicada. Nosso foco é entender sua necessidade e entregar 
            exatamente o que seu negócio precisa para 
            <strong> decolar online</strong>.
          </p>          
          {/* <div className="stats">
            <div className="stat-item">
              <h4>50+</h4>
              <p>Projetos Entregues</p>
            </div>
            <div className="stat-item">
              <h4>5+</h4>
              <p>Anos de Experiência</p>
            </div>
            <div className="stat-item">
              <h4>100%</h4>
              <p>Clientes Satisfeitos</p>
            </div>
          </div> */}
        </div>
        
        
        <div className="sobre-image">
          <img 
            src="https://onlinup.com/galeria/fotoperfil_Patricia.png" 
            alt="Patrícia - Criadora da OnlinUp"
            style={{
              width: '100%',
              height: '400px',
              objectFit: 'cover',
              borderRadius: '20px'
            }}
          />
        </div>      </div>
    </section>
  );
}

export default Sobre;